const getImageBase64 = async (locale:string, imageUrl: string) => {
  try {
    let response:any = null;
    if(imageUrl.startsWith('https://asset.productmarketingcloud.com')){
      response = await fetch(`/${locale}/api/proxy-download-file/`, {
        method: 'POST',
        body: JSON.stringify({ fileUrl:imageUrl }),
      });
    }else{
      response = await fetch(imageUrl);
    }

    if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);

    const blob = await response.blob();

    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result?.toString().split(',')[1] || '';
        resolve(result);
      };
      reader.onerror = (err) => {
        console.warn(`FileReader error: ${err}`);
        resolve('');
      };
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn(`Image fetch failed for URL ${imageUrl}:`, err);
    return '';
  }
};
export default getImageBase64;
